module.exports = __webpack_public_path__ + "img/seven4Orange.ae72e539.jpg";